// Used for reCAPTCHA v2, implemented by Google, for the signup dialogs.
export const GOOGLE_SITE_KEY = '6LdBiRQUAAAAALKQtuR3v9R6ypwGLfTr8ubkky7-'

// Links
export const HELP_CENTER_LINK = 'https://support.noteflight.com'
export const FAQ_LINK =
  'https://support.noteflight.com/hc/en-us/sections/360003049952-Frequently-Asked-Questions'
export const SUPPORT_LINK =
  'https://support.noteflight.com/hc/en-us/articles/360022145092-Submit-a-Support-Request-'
export const BLOG_LINK = 'https://notes.noteflight.com/'
export const FEEDBACK_LINK = 'http://feedback.noteflight.com'
export const PRESS_LINK = 'https://notes.noteflight.com/category/news/press/'
export const FACEBOOK_LINK = 'https://www.facebook.com/Noteflight'
export const TWITTER_LINK = 'https://twitter.com/noteflight'
export const INSTAGRAM_LINK = 'https://www.instagram.com/noteflight_music'

// View types
export enum ViewType {
  LIST = 'list',
  GRID = 'grid',
  THUMBNAIL = 'thumbnail',
}

// Local Storage
export const PRODUCT_VIEW_TYPE_KEY = '_nf_products_view_type'
export const SCORES_VIEW_TYPE_KEY = '_nf_scores_view_type'
export const THEME_TYPE_KEY = '_nf_theme'
export const PURCHASING_QUANTITY_KEY = '_nf_product_purchasing'
export const LOCAL_EDITS_KEY_PREFIX = '_nf_localEdits_'
export const LOCAL_DRAFT_KEY_PREFIX = '_nf_draft_'

// Session Storage
export const PROFILE_EPOCH_KEY = '_nf_profile_epoch'

// Emails
export const SUPPORT_EMAIL = 'support@noteflight.com'

// Theme types
export enum ThemeType {
  SYSTEM_DEFAULT = 'default',
  LIGHT = 'light',
  DARK = 'dark',
}
